import { axios } from '@/utils/request'

const account={
    isTenantAvailable(parameter) {
        return axios({
            url: '/api/services/app/Account/IsTenantAvailable',
            method: 'post',
            data: parameter
        })
    }
}
export default account